import type { CompleteAttachmentUploadResponse } from "@nlc/shared-types";

import authenticatedApi from "@/lib/api/client";

export function completeAttachmentUpload(
  attachmentId: number,
): Promise<CompleteAttachmentUploadResponse> {
  return authenticatedApi
    .url(`/attachments/${attachmentId}/complete`)
    .post()
    .json<CompleteAttachmentUploadResponse>();
}

export function deleteAttachment(attachmentId: number): Promise<Response> {
  return authenticatedApi.url(`/attachments/${attachmentId}`).delete().res();
}
